import { EVENT_TIME_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useDayjs } from '@/lib/utils/useDayjs';
import { createFragmentArrayParser } from '@liquorice/gql-utils';
import { toBoolean, toId, toNumber, toString, toStringOrNull } from '@liquorice/utils';
import { EventTimeCardFragment, EventTimeFragment } from '@/__generated__/graphql';

export interface EventTime {
  id?: string | null;
  eventId?: string | null; // Optional as we don't have this in fragment querying
  eventEntryId?: string | null; // Optional as imported event times don't have Craft Ids yet
  eventTimeId: string | null;
  date: string;
  availableSeats?: number;
  soldout?: boolean;
  status?: boolean;
  isPast?: boolean; // Optional field to indicate if the event time is in the past
  waitlist?: boolean;
}

export interface EventTimeWithHash extends EventTime {
  eventTimeImportHash: string;
}

export const parseEventTime = (
  data: Maybe<EventTimeCardFragment | EventTimeFragment>
): EventTime | null => {
  if (!data) return null;

  const { date, ownerId, eventTimeId, availableSeats, waitlist, eventTimeStatus, id } = data;

  const isPast = useDayjs(date).isBefore(useDayjs(), 'day');

  return {
    id: toId(id),
    eventTimeId: toStringOrNull(eventTimeId),
    eventEntryId: toString(ownerId),
    date: toString(date),
    availableSeats: toNumber(availableSeats),
    soldout: toNumber(availableSeats) === 0, // Assuming soldout means no available seats
    status: toBoolean(eventTimeStatus),
    waitlist: toBoolean(waitlist),
    isPast,
  };
};

export const parseEventTimeFragment = createFragmentArrayParser(
  EVENT_TIME_CARD_FRAGMENT,
  (items) => {
    return items.map((item) => parseEventTime(item)).filter(Boolean) as EventTime[];
  }
);
